'use client';

import React, { useRef, useEffect, useState, useCallback } from 'react';
import { Link } from 'react-router-dom';

export default function Nav() {
  // Añade la nueva clave Soluciones
  const [showSublinks, setShowSublinks] = useState({
    Productos: false,
    Soluciones: false,
    Nosotros: false,
  });

  const dropdownRef = useRef(null);

  const closeDropdown = useCallback(() => {
    setShowSublinks({ Productos: false, Soluciones: false, Nosotros: false });
  }, []);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        closeDropdown();
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [closeDropdown]);

  // +––– LINKS –––+
  const links = [
    { name: 'Inicio', path: '/' },
    {
      name: 'Productos',
      sublinks: [
        { name: 'Radios portátiles', path: '/productos/radios-portatiles' },
        { name: 'Radios móviles',   path: '/productos/radios-moviles' },
        { name: 'Repetidoras',      path: '/productos/repetidoras' },
        { name: 'Accesorios',       path: '/productos/accesorios' },
        { name: 'Equipos PoC',      path: '/productos/equipos-poc' },
        { name: 'Bodycams',         path: '/productos/bodycams' },
      ],
    },
    {
      name: 'Soluciones',                          // ⬅️ NUEVA SECCIÓN
      sublinks: [
        { name: 'BN100',             path: '/soluciones/bn100' },
        { name: 'IP Transit',        path: '/soluciones/ip-transit' },
        { name: 'SmartDispatch Plus',path: '/soluciones/smartdispatch' },
        { name: 'XPT',               path: '/soluciones/xpt' },
      ],
    },
    {
      name: 'Nosotros',
      sublinks: [
        { name: 'Quiénes somos', path: '/nosotros' },
        { name: 'Contacto',      path: '/contacto' },
      ],
    },
  ];

  const toggleSublinks = (e, linkName) => {
    const link = links.find((l) => l.name === linkName);
    if (!link?.sublinks) return; // navega si no hay sublinks
    e.preventDefault();

    const reset = Object.keys(showSublinks).reduce(
      (acc, key) => ({ ...acc, [key]: false }), {}
    );

    setShowSublinks({ ...reset, [linkName]: !showSublinks[linkName] });
  };

  return (
    <nav className="w-full" ref={dropdownRef}>
      <ul className="flex justify-center gap-x-4 items-center">
        {links.map((link) => (
          <li key={link.name} className="relative">
            <Link
              to={link.path}
              onClick={(e) => toggleSublinks(e, link.name)}
              onKeyDown={(e) => e.key === 'Enter' && toggleSublinks(e, link.name)}
              className="flex items-center font-bold uppercase px-4 py-2 text-purple-600 hover:text-purple-800 hover:bg-gray-100 rounded duration-300"
            >
              {link.name}
              {link.sublinks && (
                <svg
                  className={`ml-1 w-4 transition-transform duration-300 ${showSublinks[link.name] ? 'rotate-180' : ''}`}
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M6.293 7.293a1 1 0 011.414 0L10 9.586l2.293-2.293a1 1 0
                       111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
                    clipRule="evenodd"
                  />
                </svg>
              )}
            </Link>

            {link.sublinks && (
              <ul
                className={`absolute mt-2 w-52 rounded-b bg-white border shadow px-2 py-2 z-20 transition-all duration-300
                  ${showSublinks[link.name] ? 'opacity-100 scale-100 pointer-events-auto'
                                           : 'opacity-0 scale-95 pointer-events-none'}`}
              >
                {link.sublinks.map((sublink, i) => (
                  <li key={sublink.name} className={i < link.sublinks.length - 1 ? 'border-b mb-1 pb-1' : ''}>
                    <Link
                      to={sublink.path}
                      onClick={closeDropdown}
                      onKeyDown={(e) => e.key === 'Enter' && closeDropdown()}
                      className="block w-full font-semibold px-6 py-2 rounded hover:bg-purple-800 hover:text-white duration-300 uppercase"
                    >
                      {sublink.name}
                    </Link>
                  </li>
                ))}
              </ul>
            )}
          </li>
        ))}
      </ul>
    </nav>
  );
}
